import CreateNewRoom from './CreateNewRoom.container';

export default CreateNewRoom;
